import script from "./PlacesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlacesView.vue?vue&type=script&lang=ts&setup=true"

import "./PlacesView.vue?vue&type=style&index=0&id=f4ed0560&lang=scss"

const __exports__ = script;

export default __exports__